<div class="flex h-full w-full flex-col overflow-hidden">
  <!-- Header -->
  <div class="flex w-full shrink-0 items-center justify-between px-5 py-2.5">
    <div class="flex items-center gap-1.5">
      <proffeo-avatar
        [size]="AvatarSize.SM"
        [user]="$safeNavigationMigration(files()[currentIndex()]?.createdBy())"
      ></proffeo-avatar>
      <div class="flex flex-col">
        <p class="text-sm">
          {{ files()[currentIndex()]?.createdBy()?.firstName }}
          {{ files()[currentIndex()]?.createdBy()?.lastName }}
        </p>
        <p class="text-xs">
          {{ $safeNavigationMigration(files()[currentIndex()]?.createdAt) | proffeoDate: defaultDatetimeFormat }}
        </p>
      </div>
    </div>

    <proffeo-ui-button
      (clicked)="closeDialog()"
      [ariaLabel]="'close' | translate"
      fontIcon="close"
      size="xs"
      variant="ghost"
    />
  </div>

  <proffeo-ui-divider />

  <div class="min-h-0 grow overflow-auto">
    <proffeo-full-image-carousel
      [(index)]="currentIndex"
      (descriptionChanged)="onDescriptionChanged($event)"
      (fileDelete)="onFileDeleted($event)"
      [files]="files()"
      [emblaId]="'embla-full-' + modalId"
    ></proffeo-full-image-carousel>
  </div>

  <proffeo-ui-divider />

  <div class="shrink-0 px-2">
    <proffeo-thumbnails-carousel
      [(index)]="currentIndex"
      [files]="files()"
      [emblaId]="'embla-thumbs-' + modalId"
      [showCurrentSlideIndicator]="true"
    ></proffeo-thumbnails-carousel>
  </div>
</div>
